import React from 'react';
import edjsHTML from 'editorjs-html';

const BlogViewer = ({ content }) => {
  if (!content) {
    return <div>No content available</div>;
  }

  // Parse content if it's a string
  let parsedContent = content;
  if (typeof content === 'string') {
    try {
      parsedContent = JSON.parse(content);
    } catch (error) {
      console.error('Error parsing content string:', error);
      return <div>Invalid content format</div>;
    }
  }

  // Check if parsedContent has blocks
  if (!parsedContent || !parsedContent.blocks || !Array.isArray(parsedContent.blocks)) {
    console.error('Invalid content structure:', parsedContent);
    return <div className="text-gray-500 italic">No content available</div>;
  }

  // Check if blocks array is empty
  if (parsedContent.blocks.length === 0) {
    return <div className="text-gray-500 italic">This blog post has no content yet.</div>;
  }

  const edjsParser = edjsHTML();
  let html;

  try {
    html = edjsParser.parse(parsedContent);

    // Handle when parser returns a string (happens with empty or invalid blocks)
    if (typeof html === 'string') {
      // If it's an empty string, show no content message
      if (!html.trim()) {
        return <div className="text-gray-500 italic">This blog post has no content yet.</div>;
      }
      // If it's a non-empty string, wrap it in an array
      html = [html];
    }

    // Ensure html is an array
    if (!Array.isArray(html)) {
      console.error('Parser did not return an array:', html);
      // If it's an object, try to extract values
      if (typeof html === 'object' && html !== null) {
        html = Object.values(html);
      } else {
        html = [];
      }
    }

    // Filter out any empty or invalid items
    html = html.filter(item => item && typeof item === 'string' && item.trim() !== '');
  } catch (error) {
    console.error('Error parsing blog content:', error);
    html = [];
  }

  if (html.length === 0) {
    return <div className="text-gray-500 italic">No content available</div>;
  }

  return (
    <div className="blog-content prose prose-lg max-w-none">
      {html.map((item, index) => {
        return typeof item === 'string'
          ? <div key={index} dangerouslySetInnerHTML={{ __html: item }} />
          : null;
      })}
    </div>
  );
};

export default BlogViewer;
